import { Box, List, ListItem, Typography } from '@mui/material';
import {
  FeatureContent,
  FeatureDescription,
  FeatureListTitle,
  FeatureTitle,
  FeatureCard,
  IconContainer,
  FeatureItemContent,
  Styled,
} from './FeatureList.style';
import Image from 'next/image';
import { PrismicRichText } from '@prismicio/react';
import CheckList from 'common/assets/image/logo/icon/CheckList';

const FeatureList = ({ slice, isIconList }) => {
  const features = slice.items;

  return (
    <FeatureContent>
      {slice.primary.title && (
        <PrismicRichText
          field={slice.primary.title}
          components={{
            paragraph: ({ children }) => (
              <Typography variant="h3" sx={Styled.Title}>
                {children}
              </Typography>
            ),
          }}
        />
      )}
      {slice.primary.description && (
        <FeatureDescription>
          <PrismicRichText field={slice.primary.description} />
        </FeatureDescription>
      )}
      {slice.primary.titlelist && (
        <FeatureListTitle>{slice.primary.titlelist}</FeatureListTitle>
      )}
      <Box sx={Styled.ListContainer}>
        <List sx={Styled.FeatureList}>
          {features.map((feature, index) => (
            <ListItem key={index} sx={Styled.ListItem}>
              {isIconList ? (
                <Box sx={Styled.CheckListContainer}>
                  <Box sx={Styled.CheckListIcon}>
                    <CheckList />
                  </Box>
                  <Box sx={Styled.CheckListText}>
                    <PrismicRichText
                      field={feature.title}
                      components={{
                        paragraph: ({ children }) => (
                          <FeatureTitle>{children}</FeatureTitle>
                        ),
                        list: ({ children }) => (
                          <Box component="ul" sx={Styled.UL}>
                            {children}
                          </Box>
                        ),
                        listItem: ({ children }) => (
                          <Box component="li" sx={Styled.ListFeatureItem}>
                            {children}
                          </Box>
                        ),
                        strong: ({ children }) => (
                            <Typography
                              sx={(theme) => ({
                                color: '#636F81',
                                fontSize: '16px' // spacing(4) = 32px si spacing de base est 8
                              })}
                            >
                              {children}
                            </Typography>
                          )
                      }}
                    />
                    <Typography sx={Styled.FeatureDescriptionSmall}>
                      <PrismicRichText field={feature.description} />
                    </Typography>
                  </Box>
                </Box>
              ) : (
                <FeatureCard>
                  <IconContainer>
                    <Image
                      src={feature.icon.url}
                      alt={feature.icon.alt || 'Feature icon'}
                      width={24}
                      height={24}
                    />
                  </IconContainer>
                  <FeatureItemContent>
                    <FeatureTitle>
                      <PrismicRichText field={feature.title} />
                    </FeatureTitle>
                    <Typography sx={Styled.FeatureDescriptionCard}>
                      <PrismicRichText field={feature.description} />
                    </Typography>
                  </FeatureItemContent>
                </FeatureCard>
              )}
            </ListItem>
          ))}
        </List>
      </Box>
    </FeatureContent>
  );
};

export default FeatureList;
